import { FunctionComponent } from "react";
import {
  numberWithCommas,
  amountDesc,
  trimAddr1,
  etherscanAddressLink,
} from "@/utils/format";
import { Drawer, LoadingOverlay } from "@mantine/core";
import { useDevice } from "@/hooks/useDevice";
import type { V2Validator } from "@/services/network/validator";
import UserStakeCard from "@/components/leaderboard/UserStakeCard";
import { QuestionIcon } from "@/form/components/common/icons";
import Image from "next/image";
import BigNumber from "bignumber.js";
import RichText from "@/components/common/RichText";

const ValidatorStakeDrawer: FunctionComponent<{
  opened: boolean;
  close: any;
  validator: V2Validator | null;
}> = ({ opened, close, validator }) => {
  const { isMobile } = useDevice();
  let image = validator?.avatar || validator?.imageUrl;

  const stakedAmount = new BigNumber(validator?.stake?.stakedAmount || 0);

  return (
    <Drawer
      opened={opened}
      onClose={close}
      position={isMobile ? "bottom" : "right"}
      trapFocus={false}
      size={480}
      // overlayProps={{
      //   opacity: isMobile ? 0.6 : 0,
      // }}
      classNames={{
        content: "rounded-t-lg sm:rounded-l-lg",
      }}
      styles={{
        content: {
          boxShadow: "-3px -3px 16px rgba(0, 0, 0, 0.05)",
        },
      }}
    >
      <LoadingOverlay visible={!validator} overlayBlur={4}></LoadingOverlay>
      <div className="px-8 flex flex-col items-center pb-10">
        <div className="text-lg font-semibold">Stake</div>
        <div className="mt-6 p-6 border border-[#87B5FF] rounded-lg w-full">
          <div className="w-full h-[195px] flex items-center justify-center bg-cover bg-center relative">
            <Image
              className="rounded-lg overflow-hidden"
              src={image || "/karatdao.jpg"}
              layout="fixed"
              height={195}
              width={195}
              loading="lazy"
              placeholder="blur"
              objectFit="cover"
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcVQoAAc8BIaDXu+0AAAAASUVORK5CYII="
            ></Image>
          </div>
          <div className="mt-8 font-semibold text-center">
            {validator?.validatorName && (
              <span>{validator?.validatorName}</span>
            )}{" "}
            #{validator?.tokenId}{" "}
          </div>
          {validator?.description && (
            <RichText
              className="mt-4 text-sm text-center whitespace-pre-line"
              text={validator?.description}
            ></RichText>
          )}

          <div className="mt-8 flex items-center">
            <div className="flex flex-col items-center flex-1">
              <div className="font-bold text-xl text-tertiary">
                {amountDesc(stakedAmount.toNumber(), 2)}
              </div>
              <div className="text-sm">KAT staked</div>
            </div>
            <div className="h-10 w-[1px] bg-tertiary "></div>
            <div className="flex flex-col items-center flex-1">
              <div className="font-bold text-xl text-tertiary">
                {((validator?.stake?.percentageOfNetwork || 0) * 100).toFixed(
                  1
                )}{" "}
                %
              </div>
              <div className="text-sm">Of total network</div>
            </div>
          </div>
          <div className="mt-8 gap-4 flex flex-col text-sm">
            <div className="flex items-center justify-between text-dark1">
              <div className="font-semibold">Address</div>
              <div className="">
                <a
                  href={etherscanAddressLink(validator?.ownerAddress as string)}
                  target="_blank"
                  rel="noreferrer"
                  className="text-primary text-sm action hover:text-primary"
                >
                  {trimAddr1(validator?.ownerAddress || "", 8)}
                </a>
              </div>
            </div>
            <div className="flex items-center justify-between text-dark1">
              <div className="font-semibold flex items-center">
                Referral Score
              </div>
              <div className="">
                {numberWithCommas(validator?.karatScore || 0)}
              </div>
            </div>
            <div className="flex items-center justify-between text-dark1">
              <div className="font-semibold flex items-center">Return</div>
              <div className="">
                {((validator?.stake?.apy || 0) * 100).toFixed(2)}% APY
              </div>
            </div>
            <div className="flex items-center justify-between text-dark1">
              <div className="font-semibold flex items-center">
                Number of stakers
              </div>
              <div className="">
                {numberWithCommas(validator?.stake?.stakerAmount)}
              </div>
            </div>
          </div>
        </div>
        {validator && (
          <UserStakeCard tokenId={validator.tokenId}></UserStakeCard>
        )}

        {/* <div className="mt-6">
            <FakeUserList
              count={activeValidator?.referralNumber || 0}
              id={activeValidator?.tokenId}
            ></FakeUserList>
          </div>
          <Link href={`/mint/claimer?validatorId=${activeValidator?.tokenId}`}>
            <div className="action text-primary mt-4 font-semibold">
              Join team
            </div>
          </Link>

          <a
            target="_blank"
            rel="noreferrer"
            href={`https://www.okx.com/web3/nft/asset/zksync-era/0xbc27a252e879939b56aaeec8430b44b6721fc06e/${activeValidator?.tokenId}`}
          >
            <Button className="mt-6" radius="xl" size="md">
              Buy on marketplace
            </Button>
          </a> */}
      </div>
    </Drawer>
  );
};

export default ValidatorStakeDrawer;
